import axios from 'axios';

export function fetchUsers(partnerId) {
    var url = partnerId ? `/users/${partnerId}` : '/users';
    return axios.get(url);
}

export function saveUser(payload) {
    return axios.patch('/users/' + payload.id, payload);
}

export function newUser(payload) {
    return axios.post('/users/', payload);
}

export function removeUser(payload) {
    return axios.delete('/users/' + payload.id);
}

export function fetchCurrentUser() {
    return axios.get('/users/current');
}

export function fetchAdministrators() {
    return axios.get('/administrators');
}

export function fetchUserInvitation(token) {
    return axios.get('/users/invitations/' + token);
}

export function resetUser2FAToken(data) {
    return axios.put('/users/reset-2fa/', data);
}

export function addAdminUser(data) {
    return axios.post('/administrators', data);
}
